import { render, staticRenderFns } from "./AppointmentBooking.vue?vue&type=template&id=2a431fc4&"
import script from "./AppointmentBooking.vue?vue&type=script&lang=js&"
export * from "./AppointmentBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports